import {useNavigate} from 'react-router-dom';

const Roles = ({app}: RolesDetailProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex mt-3">
        <span className="icon-information text-blue-1 ml-2 mt-1"></span>
        <p
          className=" text-gray-6"
          onClick={() =>
            navigate(
              `${app === 'farm' ? '/farm' : '/wholesaler'}/account/roles`,
            )
          }
        >
          قوانین و شرایط استفاده از حجره
        </p>
      </div>
    </>
  );
};

export default Roles;
